import { ResourceId } from '@wix/wix-help-widget-common/homepage';

export enum SupportType {
  Article = 'Article',
  Category = 'category',
  SubCategory = 'sub_category',
  Link = 'link',
  Button = 'button',
  Text = 'text',
  AllHelpTopics = 'all_help_topics',
  // There will be other values like "Videos", "FAQ" etc.
}

export enum BlockType {
  Solution = 'Solution',
  CategoryList = 'category_list',
  SubCategoryList = 'sub_category_list',
  SolutionList = 'solution_list',
  Link = 'link',
  Button = 'button',
  Tab = 'tab',
  Breadcrumbs = 'Breadcrumbs',
  // There will be other values like "Button" etc.
}

export enum BlockId {
  SearchResults = 1,
  SingleArticle,
  EmptyHomePage,
  AllHelpTopics,
  SubCategory,
  SolutionList,
  Homepage,
  RecommendedArticle,
  HelpCenter,
  ContactUsButton,
  ChatWithUs,
  HirePartnerButton,
  SuccessManager,
  StatusPage,
  Resources,
  Breadcrumbs,
  ShareFeedback,
  RequestSuccessManager,
}

export const blockNames: Record<BlockId, string> = {
  [BlockId.SearchResults]: 'Search Results',
  [BlockId.SingleArticle]: 'Single Article',
  [BlockId.EmptyHomePage]: 'Empty Home Page',
  [BlockId.AllHelpTopics]: 'All Help Topics',
  [BlockId.SubCategory]: 'Sub Category',
  [BlockId.SolutionList]: 'Solution List',
  [BlockId.Homepage]: 'Homepage',
  [BlockId.RecommendedArticle]: 'Recommended Article',
  [BlockId.HelpCenter]: 'Help Center',
  [BlockId.ContactUsButton]: 'Contact Us Button',
  [BlockId.ChatWithUs]: 'Chat With Us',
  [BlockId.HirePartnerButton]: 'Hire Partner Button',
  [BlockId.SuccessManager]: 'Success Manager',
  [BlockId.StatusPage]: 'Status Page Button',
  [BlockId.Resources]: 'Resources',
  [BlockId.Breadcrumbs]: 'Breadcrumbs',
  [BlockId.ShareFeedback]: 'Share Feedback',
  [BlockId.RequestSuccessManager]: 'Request Success Manager',
};

export const homepageResourcesName: Record<ResourceId, string> = {
  [ResourceId.WixLearn]: 'Wix Learn',
  [ResourceId.WixBlog]: 'Wix Blog',
  [ResourceId.SEOLearningHub]: 'SEO Learning Hub',
  [ResourceId.VeloHub]: 'Velo',
  [ResourceId.PartnersForum]: 'Partners Forum',
  [ResourceId.CustomerCareTickets]: 'View Customer Care tickets',
  [ResourceId.HireAnotherProfessional]: 'Hire another professional',
  [ResourceId.CommunityForum]: 'Visit the community forum',
  [ResourceId.StudioCommunityForum]: 'Visit the community forum',
  [ResourceId.WixDevelopers]: 'Wix Developers',
};

export enum ShareFeedbackItemsName {
  ReportABug = 'Report A Bug',
  RequestAFeature = 'Request A Feature',
}

export enum UserContactsItemsName {
  Email = 'Email',
  PhoneNumber = 'Phone Number',
  Timezone = 'Timezone',
  BookASessionLink = 'Book A Session Link',
}

export type BlockDetails = Readonly<{
  support_type: SupportType;
  support_id: string | null;
  support_position: number;
  support_name?: string;
}>;

export type SolutionInfo = Readonly<{
  block_id: BlockId;
  block_name: string;
  block_position: number;
  block_type: BlockType;
  block_details: readonly BlockDetails[] | null;
  url?: string;
  text?: string;
  section_text?: string;
}>;
